import Button from "@edaz/edazkit/Button";
import React from "react";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import PairingByOrderPaymentsListViewModel from "viewModels/finance/paymentsPairing/pairingByOrder/pairingByOrderPaymentsListViewModel";
import type UnpairedPayment from "entities/unpairedPayment";
import ListView from "../../../common/list";
import PaymentFilters from "../paymentFilters";
import { unpairedPaymentsColumns } from "../pairingByPayment/pairingByPaymentListView";

export const PairingByOrderPaymentsListView: ViewComponent<PairingByOrderPaymentsListViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<UnpairedPayment>[] = [
    ...unpairedPaymentsColumns(vm),
    {
      cellClassName: "sticky",
      headerClassName: "sticky",
      valueFormatter: props => {
        if (vm.allowToPair) {
          return (
            <ButtonToolbar className="justify-content-end">
              <Button className="rounded" size="sm" onClick={() => vm.onPairPaymentClick(props.item)}>
                {vm.translate("pair")}
              </Button>
            </ButtonToolbar>
          );
        }
      },
    },
  ];

  return (
    <>
      <h4 className="my-4">{vm.translate("paymentSearch")}</h4>
      <PaymentFilters vm={vm} />
      <ListView
        columns={columns}
        vm={vm}
        hideTitle={true}
        rowProps={item => {
          if (item === vm.openPayment) {
            return {
              className: "table-active",
            };
          }

          return {};
        }}
      />
    </>
  );
});

registerView(PairingByOrderPaymentsListView, PairingByOrderPaymentsListViewModel);
